export const doRequest = (url, method = 'GET', options = {}) => fetch(
  `${process.env.REACT_APP_REST_API_HOST}/${url}`,
  { method, ...options },
).then(res => res.json());

export default doRequest;